/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Linked_NoInputs */

const vi_shop_account_linked_no = /** @type {(inputs: Shop_Account_Linked_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa liên kết`)
};

/**

* @param {Shop_Account_Linked_NoInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_linked_no = /** @type {((inputs?: Shop_Account_Linked_NoInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Linked_NoInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_linked_no(inputs)
});